<template>
  <YdDialog
    ref="activitiesAdd"
    title="新建首单优惠"
    :visible.sync="visible"
    :before-close="handleClose"
    width="68%"
  >
    <el-form ref="form" :model="form" size="small" :rules="rules" label-width="100px">
      <el-form-item label="活动名称：" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入活动名称"
          clearable
          maxlength="20"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="活动时间：">
        <avue-date
          v-model="dates"
          type="datetimerange"
          prop="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          valueFormat="yyyy-MM-dd HH:mm:ss"
          @change="handleSelectDate"
        />
      </el-form-item>
      <el-form-item label="隶属公司：">
        <span style="padding-left: 8px">
          <el-button type="primary" size="mini" :disabled="isDisabled" @click.stop="handleMerchant"
            >添加</el-button
          >
        </span>
        <span style="padding-left: 10px">
          <el-checkbox
            v-model="form.isAll"
            true-label="1"
            false-label="0"
            @change="handleEnabledChecked"
            >全选</el-checkbox
          >
        </span>
        <block v-for="(item, index) of merchantLists" :key="index">
          <div class="acea-row row-middle">
            <i class="el-icon-remove-outline" @click="remove(index)"></i>
            <span class="mr5">{{ item.merchantName }}</span>
          </div>
          <div style="padding-left: 10px">
            <el-card class="box-card">
              <div style="padding: 8px">
                <block v-for="(citem, index) of item.lineIds" :key="index">
                  <span style="margin: 6px">
                    <el-checkbox v-model="citem.check" true-label="1" false-label="0" border>{{
                      citem.lineName
                    }}</el-checkbox>
                  </span>
                </block>
              </div>
            </el-card>
          </div>
        </block>
      </el-form-item>
      <el-form-item label="活动奖励：">
        减
        <span
          ><avue-input-number
            minRows="0"
            precision="2"
            v-model="form.discountsMoney"
            style="width: 10vw"
        /></span>
        元
      </el-form-item>
      <el-form-item label="是否可选优惠券：" label-width="110">
        <avue-radio
          v-model="form.isChooseCoupon"
          :dic="[
            { label: '是', value: 1 },
            { label: '否', value: 0 }
          ]"
        />
      </el-form-item>
      <el-form-item label="互斥" v-if="form.isChooseCoupon === 1">
        <el-checkbox
          v-model="form.isUserCoupon"
          true-label="0"
          false-label="1"
          @change="handleIsUserCoupon"
          >与所有优惠券互斥</el-checkbox
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="reset">取 消</el-button>
      <el-button type="primary" size="small" @click="submit">保 存</el-button>
    </div>
    <select-merchant ref="merchant" v-if="selectMerchantVisible" />
  </YdDialog>
</template>

<script>
  import { save } from '@/api/marketing/activities-api'
  import selectMerchant from '../../components/select-merchant'

  export default {
    name: 'activitiesAdd',
    components: {
      selectMerchant
    },
    data() {
      return {
        visible: false,
        selectMerchantVisible: false,
        merchantDic: [],
        isDisabled: false,
        dates: [],
        form: {
          isAll: '0',
          isChooseCoupon: 0,
          isUserCoupon: 1
        },
        rules: {
          name: [{ required: true, message: '活动名称不能为空', trigger: 'blur' }]
        }
      }
    },
    computed: {
      merchantLists: {
        get() {
          return this.$store.state.coupon.merchantLinesActi
        },
        set(val) {
          this.$store.commit('UPDATE_MERCHANT_ACTI', val)
        }
      }
    },
    methods: {
      init() {
        this.visible = true
      },
      handleEnabledChecked(val) {
        if (val === '0') {
          this.isDisabled = false
          this.form.merchantId = ''
        }
        if (val === '1') {
          this.$store.commit('REMOVE_MERCHANT_ACTI', [])
          this.isDisabled = true
        }
      },
      handleSelectDate(val) {
        this.form.startTime = val[0]
        this.form.endTime = val[1]
      },
      reset() {
        this.visible = false
        this.form = {
          startTime: null,
          endTime: null,
          isAll: '0',
          isChooseCoupon: 0
        }
        this.$store.commit('REMOVE_MERCHANT_ACTI', [])
        window.location.reload()
        this.$refs.form.resetFields()
      },
      submit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.form.merchantAndLines = this.merchantLists
            save(this.form).then((resp) => {
              if (resp.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.$emit('refreshDataList')
                    this.reset()
                  }
                })
              }
            })
          }
        })
      },
      handleMerchant() {
        this.selectMerchantVisible = true
        this.$nextTick(() => {
          this.$refs.merchant.init('A')
        })
      },
      remove(index) {
        this.$store.commit('DELETE_MERCHANGT_ACTI', index)
      },
      handleIsUserCoupon(val) {
        console.log(val)
        this.form.isUserCoupon = val
      },
      handleClose(done) {
        this.$store.commit('REMOVE_MERCHANT_ACTI', [])
        window.location.reload()
        this.$refs.form.resetFields()
        done()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .acea-row {
    display: flex;
    flex-wrap: wrap;
  }

  .acea-row.row-middle {
    align-items: center;
    padding-left: 12px;
    padding-top: 12px;
  }
  .mr5 {
    padding-left: 8px;
  }

  .box-card {
    width: 600px;
    padding: 5px;
  }
  ::v-deep .el-card__body {
    padding: 0;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
  }
</style>
